module.exports = __webpack_public_path__ + "static/car6-f1fe884e8eecfa33a40de31927744b69.png";